/* eslint-disable sort-keys */
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useBuildVars, useInX4AFrame, useSiteConfig } from 'mf_core/config';
import { useIsAuthenticated, useDecodedToken } from 'mf_core/auth';
import { injectCategorizedScriptInHead, injectScriptInHead } from './utils';
import { setDigitalData } from 'mf_core/adobe';
import { useIsOneTrustEnabled } from './useOneTrust';

const scriptsMap: any = {
  development: {
    au: 'https://assets.adobedtm.com/a8f91053d00e/7dee3b1c3a2e/launch-57cb68d55aa5-development.min.js',
    hu: 'https://assets.adobedtm.com/a8f91053d00e/fcdbd931f888/launch-e6b48686272c-development.min.js',
    no: 'https://assets.adobedtm.com/a8f91053d00e/8a89b29c8be2/launch-faa9e163c865-development.min.js',
    pt: 'https://assets.adobedtm.com/a8f91053d00e/4dbad6f05dd3/launch-1b8354a0a2b1-development.min.js',
    se: 'https://assets.adobedtm.com/a8f91053d00e/20a4caef2031/launch-4bb9deb3ab5a-development.min.js',
    ch: 'https://assets.adobedtm.com/a8f91053d00e/85f63646e5c0/launch-ec090a5f6fae-development.min.js',
    pe: 'https://assets.adobedtm.com/a8f91053d00e/6f82277d6ca9/launch-df92986366a4-development.min.js',
    cl: 'https://assets.adobedtm.com/a8f91053d00e/f2d3be813f06/launch-0d00f4fa20c2-development.min.js',
    br: 'https://assets.adobedtm.com/a8f91053d00e/632dfaefbac3/launch-e022eee9741a-development.min.js',
    nz: 'https://assets.adobedtm.com/a8f91053d00e/fcb6adc7fc1e/launch-fb39cdd6fc0a-development.min.js',
    hk: 'https://assets.adobedtm.com/a8f91053d00e/ffca6e56a5e2/launch-1a40686158a8-development.min.js',
    id: 'https://assets.adobedtm.com/a8f91053d00e/a1f93e96c7a6/launch-6c8910d34bb3-development.min.js',
    sg: 'https://assets.adobedtm.com/a8f91053d00e/7e87379c86eb/launch-972c1fce5d0c-development.min.js',
    mi: 'https://assets.adobedtm.com/a8f91053d00e/3c6362756e02/launch-d82f52176b88-development.min.js',
    usme: 'https://assets.adobedtm.com/a8f91053d00e/3c6362756e02/launch-d82f52176b88-development.min.js',
  },

  production: {
    ch: 'https://assets.adobedtm.com/a8f91053d00e/85f63646e5c0/launch-30f9632e57e0.min.js',
    pe: 'https://assets.adobedtm.com/a8f91053d00e/6f82277d6ca9/launch-f1b4b30d2b84.min.js',
    at: 'https://assets.adobedtm.com/a8f91053d00e/06a6cb51c3d4/launch-0219d972a72c.min.js',
    au: 'https://assets.adobedtm.com/a8f91053d00e/7dee3b1c3a2e/launch-ef5fbd3b12de.min.js',
    be: 'https://assets.adobedtm.com/a8f91053d00e/285753d4b8f2/launch-cdc63027d33f.min.js',
    ca: 'https://assets.adobedtm.com/a8f91053d00e/a72ffeec43fd/launch-897c6aa7c43b.min.js',
    co: 'https://assets.adobedtm.com/a8f91053d00e/8344def90c44/launch-70af85e98de9.min.js',
    cl: 'https://assets.adobedtm.com/a8f91053d00e/f2d3be813f06/launch-1d8a24986064.min.js',
    de: 'https://assets.adobedtm.com/a8f91053d00e/61cdfd8ddaaf/launch-69e6d4db4b67.min.js',
    es: 'https://assets.adobedtm.com/a8f91053d00e/9b05ee515724/launch-0e26513cdfe2.min.js',
    fr: 'https://assets.adobedtm.com/a8f91053d00e/fa0362fa89e0/launch-a1c65e61b822.min.js',
    gb: 'https://assets.adobedtm.com/a8f91053d00e/9b034aa49568/launch-b3b2cf368281.min.js',
    hu: 'https://assets.adobedtm.com/a8f91053d00e/fcdbd931f888/launch-c34e0a20479b.min.js',
    in: 'https://assets.adobedtm.com/a8f91053d00e/efa4493a351d/launch-25dd3caf5fef.min.js',
    it: 'https://assets.adobedtm.com/a8f91053d00e/746db32a8133/launch-938443167cde.min.js',
    mi: 'https://assets.adobedtm.com/a8f91053d00e/3c6362756e02/launch-70908e6bc0b0.min.js',
    usme: 'https://assets.adobedtm.com/a8f91053d00e/3c6362756e02/launch-70908e6bc0b0.min.js',
    mx: 'https://assets.adobedtm.com/a8f91053d00e/69cf864b3e52/launch-2c9f828b62c9.min.js',
    nl: 'https://assets.adobedtm.com/a8f91053d00e/d92081ab8a7c/launch-a0600400854c.min.js',
    no: 'https://assets.adobedtm.com/a8f91053d00e/8a89b29c8be2/launch-1f82bc770ac2.min.js',
    nz: 'https://assets.adobedtm.com/a8f91053d00e/fcb6adc7fc1e/launch-baed6ad97089.min.js',
    pt: 'https://assets.adobedtm.com/a8f91053d00e/4dbad6f05dd3/launch-26468851ca97.min.js',
    se: 'https://assets.adobedtm.com/a8f91053d00e/20a4caef2031/launch-c554d38f9660.min.js',
    us: 'https://assets.adobedtm.com/a8f91053d00e/363a875b9ddd/launch-b0e54efb61f7.min.js',
    id: 'https://assets.adobedtm.com/a8f91053d00e/a1f93e96c7a6/launch-328bf85d754f.min.js',
    sg: 'https://assets.adobedtm.com/a8f91053d00e/7e87379c86eb/launch-0cb14f9319aa.min.js',
  },
  productionbeta: {
    ch: 'https://assets.adobedtm.com/a8f91053d00e/85f63646e5c0/launch-30f9632e57e0.min.js',
    pe: 'https://assets.adobedtm.com/a8f91053d00e/6f82277d6ca9/launch-f1b4b30d2b84.min.js',
    cl: 'https://assets.adobedtm.com/a8f91053d00e/f2d3be813f06/launch-1d8a24986064.min.js',
    br: 'https://assets.adobedtm.com/a8f91053d00e/632dfaefbac3/launch-e13f863702cc.min.js',
    nz: 'https://assets.adobedtm.com/a8f91053d00e/fcb6adc7fc1e/launch-baed6ad97089.min.js',
    hk: 'https://assets.adobedtm.com/a8f91053d00e/ffca6e56a5e2/launch-6335b0c7b461.min.js',
    id: 'https://assets.adobedtm.com/a8f91053d00e/a1f93e96c7a6/launch-328bf85d754f.min.js',
    sg: 'https://assets.adobedtm.com/a8f91053d00e/7e87379c86eb/launch-0cb14f9319aa.min.js',
    at: 'https://assets.adobedtm.com/a8f91053d00e/06a6cb51c3d4/launch-0219d972a72c.min.js',
    au: 'https://assets.adobedtm.com/a8f91053d00e/7dee3b1c3a2e/launch-ef5fbd3b12de.min.js',
    be: 'https://assets.adobedtm.com/a8f91053d00e/285753d4b8f2/launch-cdc63027d33f.min.js',
    ca: 'https://assets.adobedtm.com/a8f91053d00e/a72ffeec43fd/launch-897c6aa7c43b.min.js',
    co: 'https://assets.adobedtm.com/a8f91053d00e/8344def90c44/launch-70af85e98de9.min.js',
    de: 'https://assets.adobedtm.com/a8f91053d00e/61cdfd8ddaaf/launch-69e6d4db4b67.min.js',
    es: 'https://assets.adobedtm.com/a8f91053d00e/9b05ee515724/launch-0e26513cdfe2.min.js',
    fr: 'https://assets.adobedtm.com/a8f91053d00e/fa0362fa89e0/launch-a1c65e61b822.min.js',
    gb: 'https://assets.adobedtm.com/a8f91053d00e/9b034aa49568/launch-b3b2cf368281.min.js',
    hu: 'https://assets.adobedtm.com/a8f91053d00e/fcdbd931f888/launch-c34e0a20479b.min.js',
    in: 'https://assets.adobedtm.com/a8f91053d00e/efa4493a351d/launch-25dd3caf5fef.min.js',
    it: 'https://assets.adobedtm.com/a8f91053d00e/746db32a8133/launch-938443167cde.min.js',
    mi: 'https://assets.adobedtm.com/a8f91053d00e/3c6362756e02/launch-70908e6bc0b0.min.js',
    usme: 'https://assets.adobedtm.com/a8f91053d00e/3c6362756e02/launch-70908e6bc0b0.min.js',
    mx: 'https://assets.adobedtm.com/a8f91053d00e/69cf864b3e52/launch-2c9f828b62c9.min.js',
    nl: 'https://assets.adobedtm.com/a8f91053d00e/d92081ab8a7c/launch-a0600400854c.min.js',
    no: 'https://assets.adobedtm.com/a8f91053d00e/8a89b29c8be2/launch-1f82bc770ac2.min.js',
    pt: 'https://assets.adobedtm.com/a8f91053d00e/4dbad6f05dd3/launch-26468851ca97.min.js',
    se: 'https://assets.adobedtm.com/a8f91053d00e/20a4caef2031/launch-c554d38f9660.min.js',
    us: 'https://assets.adobedtm.com/a8f91053d00e/363a875b9ddd/launch-b0e54efb61f7.min.js',
  },
  productionbetax: {
    at: 'https://assets.adobedtm.com/a8f91053d00e/06a6cb51c3d4/launch-0219d972a72c.min.js',
    au: 'https://assets.adobedtm.com/a8f91053d00e/7dee3b1c3a2e/launch-ef5fbd3b12de.min.js',
    be: 'https://assets.adobedtm.com/a8f91053d00e/285753d4b8f2/launch-cdc63027d33f.min.js',
    ca: 'https://assets.adobedtm.com/a8f91053d00e/a72ffeec43fd/launch-897c6aa7c43b.min.js',
    co: 'https://assets.adobedtm.com/a8f91053d00e/8344def90c44/launch-70af85e98de9.min.js',
    cl: 'https://assets.adobedtm.com/a8f91053d00e/f2d3be813f06/launch-1d8a24986064.min.js',
    de: 'https://assets.adobedtm.com/a8f91053d00e/61cdfd8ddaaf/launch-69e6d4db4b67.min.js',
    es: 'https://assets.adobedtm.com/a8f91053d00e/9b05ee515724/launch-0e26513cdfe2.min.js',
    fr: 'https://assets.adobedtm.com/a8f91053d00e/fa0362fa89e0/launch-a1c65e61b822.min.js',
    gb: 'https://assets.adobedtm.com/a8f91053d00e/9b034aa49568/launch-b3b2cf368281.min.js',
    hu: 'https://assets.adobedtm.com/a8f91053d00e/fcdbd931f888/launch-c34e0a20479b.min.js',
    in: 'https://assets.adobedtm.com/a8f91053d00e/efa4493a351d/launch-25dd3caf5fef.min.js',
    it: 'https://assets.adobedtm.com/a8f91053d00e/746db32a8133/launch-938443167cde.min.js',
    mi: 'https://assets.adobedtm.com/a8f91053d00e/3c6362756e02/launch-70908e6bc0b0.min.js',
    usme: 'https://assets.adobedtm.com/a8f91053d00e/3c6362756e02/launch-70908e6bc0b0.min.js',
    mx: 'https://assets.adobedtm.com/a8f91053d00e/69cf864b3e52/launch-2c9f828b62c9.min.js',
    nl: 'https://assets.adobedtm.com/a8f91053d00e/d92081ab8a7c/launch-a0600400854c.min.js',
    no: 'https://assets.adobedtm.com/a8f91053d00e/8a89b29c8be2/launch-1f82bc770ac2.min.js',
    nz: 'https://assets.adobedtm.com/a8f91053d00e/fcb6adc7fc1e/launch-baed6ad97089.min.js',
    pt: 'https://assets.adobedtm.com/a8f91053d00e/4dbad6f05dd3/launch-26468851ca97.min.js',
    se: 'https://assets.adobedtm.com/a8f91053d00e/20a4caef2031/launch-c554d38f9660.min.js',
    us: 'https://assets.adobedtm.com/a8f91053d00e/363a875b9ddd/launch-b0e54efb61f7.min.js',
    id: 'https://assets.adobedtm.com/a8f91053d00e/a1f93e96c7a6/launch-328bf85d754f.min.js',
    sg: 'https://assets.adobedtm.com/a8f91053d00e/7e87379c86eb/launch-0cb14f9319aa.min.js',
  },
  staging: {
    ch: 'https://assets.adobedtm.com/a8f91053d00e/85f63646e5c0/launch-eed9d036a6b7-staging.min.js',
    pe: 'https://assets.adobedtm.com/a8f91053d00e/6f82277d6ca9/launch-036d60a59bcc-staging.min.js',
    cl: 'https://assets.adobedtm.com/a8f91053d00e/f2d3be813f06/launch-fbd57df79f1f-staging.min.js',
    br: 'https://assets.adobedtm.com/a8f91053d00e/632dfaefbac3/launch-7034435b45d3-staging.min.js',
    nz: 'https://assets.adobedtm.com/a8f91053d00e/fcb6adc7fc1e/launch-c0742238f6b0-staging.min.js',
    hk: 'https://assets.adobedtm.com/a8f91053d00e/ffca6e56a5e2/launch-e10f25252717-staging.min.js',
    id: 'https://assets.adobedtm.com/a8f91053d00e/a1f93e96c7a6/launch-5268930e33fd-staging.min.js',
    sg: 'https://assets.adobedtm.com/a8f91053d00e/7e87379c86eb/launch-bd74afe49d07-staging.min.js',
    at: 'https://assets.adobedtm.com/a8f91053d00e/06a6cb51c3d4/launch-e02a0574edbd-staging.min.js',
    au: 'https://assets.adobedtm.com/a8f91053d00e/7dee3b1c3a2e/launch-0b1541386cdc-staging.min.js',
    be: 'https://assets.adobedtm.com/a8f91053d00e/285753d4b8f2/launch-55ce3f721d2c-staging.min.js',
    ca: 'https://assets.adobedtm.com/a8f91053d00e/a72ffeec43fd/launch-025552be0893-staging.min.js',
    co: 'https://assets.adobedtm.com/a8f91053d00e/8344def90c44/launch-1a4e88f064db-staging.min.js',
    de: 'https://assets.adobedtm.com/a8f91053d00e/61cdfd8ddaaf/launch-cfaf45f56c15-staging.min.js',
    es: 'https://assets.adobedtm.com/a8f91053d00e/9b05ee515724/launch-6a5f443a9ff6-staging.min.js',
    fr: 'https://assets.adobedtm.com/a8f91053d00e/fa0362fa89e0/launch-44eccbbc6751-staging.min.js',
    gb: 'https://assets.adobedtm.com/a8f91053d00e/9b034aa49568/launch-34ab3000fc47-staging.min.js',
    hu: 'https://assets.adobedtm.com/a8f91053d00e/fcdbd931f888/launch-6d69215657c5-staging.min.js',
    in: 'https://assets.adobedtm.com/a8f91053d00e/efa4493a351d/launch-ae9304c9a51e-staging.min.js',
    it: 'https://assets.adobedtm.com/a8f91053d00e/746db32a8133/launch-a9117f7aadca-staging.min.js',
    mi: 'https://assets.adobedtm.com/a8f91053d00e/3c6362756e02/launch-5a61f2cf9342-staging.min.js',
    usme: 'https://assets.adobedtm.com/a8f91053d00e/3c6362756e02/launch-5a61f2cf9342-staging.min.js',
    mx: 'https://assets.adobedtm.com/a8f91053d00e/69cf864b3e52/launch-2320722bddfb-staging.min.js',
    nl: 'https://assets.adobedtm.com/a8f91053d00e/d92081ab8a7c/launch-76fcba9023bb-staging.min.js',
    no: 'https://assets.adobedtm.com/a8f91053d00e/8a89b29c8be2/launch-39844f683b39-staging.min.js',
    pt: 'https://assets.adobedtm.com/a8f91053d00e/4dbad6f05dd3/launch-973c3e41d23a-staging.min.js',
    se: 'https://assets.adobedtm.com/a8f91053d00e/20a4caef2031/launch-e1b61513841a-staging.min.js',
    us: 'https://assets.adobedtm.com/a8f91053d00e/363a875b9ddd/launch-8fea7e8865ba-staging.min.js',
  },
  staging2: {
    us: 'https://assets.adobedtm.com/a8f91053d00e/363a875b9ddd/launch-8fea7e8865ba-staging.min.js',
  },
  stagingx: {
    ch: 'https://assets.adobedtm.com/a8f91053d00e/85f63646e5c0/launch-eed9d036a6b7-staging.min.js',
    pe: 'https://assets.adobedtm.com/a8f91053d00e/6f82277d6ca9/launch-036d60a59bcc-staging.min.js',
    cl: 'https://assets.adobedtm.com/a8f91053d00e/f2d3be813f06/launch-fbd57df79f1f-staging.min.js',
    br: 'https://assets.adobedtm.com/a8f91053d00e/632dfaefbac3/launch-7034435b45d3-staging.min.js',
    nz: 'https://assets.adobedtm.com/a8f91053d00e/fcb6adc7fc1e/launch-c0742238f6b0-staging.min.js',
    hk: 'https://assets.adobedtm.com/a8f91053d00e/ffca6e56a5e2/launch-e10f25252717-staging.min.js',
    id: 'https://assets.adobedtm.com/a8f91053d00e/a1f93e96c7a6/launch-5268930e33fd-staging.min.js',
    sg: 'https://assets.adobedtm.com/a8f91053d00e/7e87379c86eb/launch-bd74afe49d07-staging.min.js',
    at: 'https://assets.adobedtm.com/a8f91053d00e/06a6cb51c3d4/launch-e02a0574edbd-staging.min.js',
    au: 'https://assets.adobedtm.com/a8f91053d00e/7dee3b1c3a2e/launch-0b1541386cdc-staging.min.js',
    be: 'https://assets.adobedtm.com/a8f91053d00e/285753d4b8f2/launch-55ce3f721d2c-staging.min.js',
    ca: 'https://assets.adobedtm.com/a8f91053d00e/a72ffeec43fd/launch-025552be0893-staging.min.js',
    co: 'https://assets.adobedtm.com/a8f91053d00e/8344def90c44/launch-1a4e88f064db-staging.min.js',
    de: 'https://assets.adobedtm.com/a8f91053d00e/61cdfd8ddaaf/launch-cfaf45f56c15-staging.min.js',
    es: 'https://assets.adobedtm.com/a8f91053d00e/9b05ee515724/launch-6a5f443a9ff6-staging.min.js',
    fr: 'https://assets.adobedtm.com/a8f91053d00e/fa0362fa89e0/launch-44eccbbc6751-staging.min.js',
    gb: 'https://assets.adobedtm.com/a8f91053d00e/9b034aa49568/launch-34ab3000fc47-staging.min.js',
    hu: 'https://assets.adobedtm.com/a8f91053d00e/fcdbd931f888/launch-6d69215657c5-staging.min.js',
    in: 'https://assets.adobedtm.com/a8f91053d00e/efa4493a351d/launch-ae9304c9a51e-staging.min.js',
    it: 'https://assets.adobedtm.com/a8f91053d00e/746db32a8133/launch-a9117f7aadca-staging.min.js',
    mi: 'https://assets.adobedtm.com/a8f91053d00e/3c6362756e02/launch-5a61f2cf9342-staging.min.js',
    usme: 'https://assets.adobedtm.com/a8f91053d00e/3c6362756e02/launch-5a61f2cf9342-staging.min.js',
    mx: 'https://assets.adobedtm.com/a8f91053d00e/69cf864b3e52/launch-2320722bddfb-staging.min.js',
    nl: 'https://assets.adobedtm.com/a8f91053d00e/d92081ab8a7c/launch-76fcba9023bb-staging.min.js',
    no: 'https://assets.adobedtm.com/a8f91053d00e/8a89b29c8be2/launch-39844f683b39-staging.min.js',
    pt: 'https://assets.adobedtm.com/a8f91053d00e/4dbad6f05dd3/launch-973c3e41d23a-staging.min.js',
    se: 'https://assets.adobedtm.com/a8f91053d00e/20a4caef2031/launch-e1b61513841a-staging.min.js',
    us: 'https://assets.adobedtm.com/a8f91053d00e/363a875b9ddd/launch-8fea7e8865ba-staging.min.js',
  },
};

const x4aFrameScriptsMap: any = {
  development:
    'https://assets.adobedtm.com/a8f91053d00e/a8292f299318/launch-1bae6d7705ff-development.min.js',
  production:
    'https://assets.adobedtm.com/a8f91053d00e/a8292f299318/launch-5afb62f26f1d.min.js',
  productionbeta:
    'https://assets.adobedtm.com/a8f91053d00e/a8292f299318/launch-5afb62f26f1d.min.js',
  staging:
    'https://assets.adobedtm.com/a8f91053d00e/a8292f299318/launch-4c69cd1fe550-staging.min.js',
  staging2:
    'https://assets.adobedtm.com/a8f91053d00e/a8292f299318/launch-4c69cd1fe550-staging.min.js',
  stagingx:
    'https://assets.adobedtm.com/a8f91053d00e/a8292f299318/launch-4c69cd1fe550-staging.min.js',
};

export const ujetFrameScriptsMap: any = {
  development: {
    ca: 'https://assets.adobedtm.com/a8f91053d00e/a72ffeec43fd/launch-4da0af444102-development.min.js',
    de: 'https://assets.adobedtm.com/a8f91053d00e/61cdfd8ddaaf/launch-b42d717b996c-development.min.js',
    es: 'https://assets.adobedtm.com/a8f91053d00e/9b05ee515724/launch-536e8b1f7afe-development.min.js',
    fr: 'https://assets.adobedtm.com/a8f91053d00e/fa0362fa89e0/launch-0e0dfd719497-development.min.js',
    mx: 'https://assets.adobedtm.com/a8f91053d00e/69cf864b3e52/launch-d6eae0223c07-development.min.js',
    uk: 'https://assets.adobedtm.com/a8f91053d00e/9b034aa49568/launch-fbb6435b71be-development.min.js',
    us: 'https://assets.adobedtm.com/a8f91053d00e/363a875b9ddd/launch-4eebef447fdb-development.min.js',
  },
  production: {
    ca: 'https://assets.adobedtm.com/a8f91053d00e/a72ffeec43fd/launch-897c6aa7c43b.min.js',
    de: 'https://assets.adobedtm.com/a8f91053d00e/61cdfd8ddaaf/launch-69e6d4db4b67.min.js',
    es: 'https://assets.adobedtm.com/a8f91053d00e/9b05ee515724/launch-0e26513cdfe2.min.js',
    fr: 'https://assets.adobedtm.com/a8f91053d00e/fa0362fa89e0/launch-a1c65e61b822.min.js',
    mx: 'https://assets.adobedtm.com/a8f91053d00e/69cf864b3e52/launch-2c9f828b62c9.min.js',
    uk: 'https://assets.adobedtm.com/a8f91053d00e/9b034aa49568/launch-b3b2cf368281.min.js',
    us: 'https://assets.adobedtm.com/a8f91053d00e/363a875b9ddd/launch-b0e54efb61f7.min.js',
  },
  productionbeta: {
    ca: 'https://assets.adobedtm.com/a8f91053d00e/a72ffeec43fd/launch-897c6aa7c43b.min.js',
    de: 'https://assets.adobedtm.com/a8f91053d00e/61cdfd8ddaaf/launch-69e6d4db4b67.min.js',
    es: 'https://assets.adobedtm.com/a8f91053d00e/9b05ee515724/launch-0e26513cdfe2.min.js',
    fr: 'https://assets.adobedtm.com/a8f91053d00e/fa0362fa89e0/launch-a1c65e61b822.min.js',
    mx: 'https://assets.adobedtm.com/a8f91053d00e/69cf864b3e52/launch-2c9f828b62c9.min.js',
    uk: 'https://assets.adobedtm.com/a8f91053d00e/9b034aa49568/launch-b3b2cf368281.min.js',
    us: 'https://assets.adobedtm.com/a8f91053d00e/363a875b9ddd/launch-b0e54efb61f7.min.js',
  },
  staging: {
    ca: 'https://assets.adobedtm.com/a8f91053d00e/a72ffeec43fd/launch-025552be0893-staging.min.js',
    de: 'https://assets.adobedtm.com/a8f91053d00e/61cdfd8ddaaf/launch-cfaf45f56c15-staging.min.js',
    es: 'https://assets.adobedtm.com/a8f91053d00e/9b05ee515724/launch-6a5f443a9ff6-staging.min.js',
    fr: 'https://assets.adobedtm.com/a8f91053d00e/fa0362fa89e0/launch-44eccbbc6751-staging.min.js',
    mx: 'https://assets.adobedtm.com/a8f91053d00e/69cf864b3e52/launch-2320722bddfb-staging.min.js',
    uk: 'https://assets.adobedtm.com/a8f91053d00e/9b034aa49568/launch-34ab3000fc47-staging.min.js',
    us: 'https://assets.adobedtm.com/a8f91053d00e/363a875b9ddd/launch-8fea7e8865ba-staging.min.js',
  },
  staging2: {
    ca: 'https://assets.adobedtm.com/a8f91053d00e/a72ffeec43fd/launch-025552be0893-staging.min.js',
    de: 'https://assets.adobedtm.com/a8f91053d00e/61cdfd8ddaaf/launch-cfaf45f56c15-staging.min.js',
    es: 'https://assets.adobedtm.com/a8f91053d00e/9b05ee515724/launch-6a5f443a9ff6-staging.min.js',
    fr: 'https://assets.adobedtm.com/a8f91053d00e/fa0362fa89e0/launch-44eccbbc6751-staging.min.js',
    mx: 'https://assets.adobedtm.com/a8f91053d00e/69cf864b3e52/launch-2320722bddfb-staging.min.js',
    uk: 'https://assets.adobedtm.com/a8f91053d00e/9b034aa49568/launch-34ab3000fc47-staging.min.js',
    us: 'https://assets.adobedtm.com/a8f91053d00e/363a875b9ddd/launch-8fea7e8865ba-staging.min.js',
  },
  stagingx: {
    ca: 'https://assets.adobedtm.com/a8f91053d00e/a72ffeec43fd/launch-025552be0893-staging.min.js',
    de: 'https://assets.adobedtm.com/a8f91053d00e/61cdfd8ddaaf/launch-cfaf45f56c15-staging.min.js',
    es: 'https://assets.adobedtm.com/a8f91053d00e/9b05ee515724/launch-6a5f443a9ff6-staging.min.js',
    fr: 'https://assets.adobedtm.com/a8f91053d00e/fa0362fa89e0/launch-44eccbbc6751-staging.min.js',
    mx: 'https://assets.adobedtm.com/a8f91053d00e/69cf864b3e52/launch-2320722bddfb-staging.min.js',
    uk: 'https://assets.adobedtm.com/a8f91053d00e/9b034aa49568/launch-34ab3000fc47-staging.min.js',
    us: 'https://assets.adobedtm.com/a8f91053d00e/363a875b9ddd/launch-8fea7e8865ba-staging.min.js',
  },
};

const UNAUTH_USER_GUID = '00000000-0000-0000-0000-000000000000';

export function useAdobeDtm() {
  const [scriptUrl, setScriptUrl] = useState('');
  const isScriptInjected = useRef(false);
  const oneTrustScript = useIsOneTrustEnabled();
  const { isInX4AFrame } = useInX4AFrame();

  const buildVars = useBuildVars();
  const siteConfig = useSiteConfig();
  const isAuthenticated = useIsAuthenticated();
  const token = useDecodedToken();
  const { pathname, search } = useLocation();

  const { buildEnvironment } = buildVars;
  const { siteCode } = siteConfig;

  useEffect(() => {
    if (buildEnvironment && siteCode) {
      const envMap = scriptsMap[buildEnvironment];
      const x4aFrameScript = x4aFrameScriptsMap[buildEnvironment];
      if (isInX4AFrame) {
        setScriptUrl(x4aFrameScript);
      } else if (envMap) {
        setScriptUrl(envMap[siteCode]);
      }
    }
  }, [buildEnvironment, isInX4AFrame, siteCode]);

  useEffect(() => {
    if (
      oneTrustScript !== 'loading' &&
      scriptUrl &&
      !isScriptInjected.current
    ) {
      if (oneTrustScript) {
        injectCategorizedScriptInHead(scriptUrl, 'optanon-category-C0001');
      } else {
        injectScriptInHead(scriptUrl);
      }
      isScriptInjected.current = true;
    }
    if (!isAuthenticated) {
      setDigitalData({ userGUID: UNAUTH_USER_GUID });
    }
  }, [scriptUrl, isAuthenticated, oneTrustScript]);

  useEffect(() => {
    const userId = token?.imoProfile?.userId;
    if (isAuthenticated && userId && typeof userId === 'string') {
      const userGUID = userId.replace(/[^0-9a-z-]/g, '');
      setDigitalData({ userGUID });
    }
  }, [token?.imoProfile?.userId, isAuthenticated]);

  // Clear digitalData object when location pathname (route) and search change
  useEffect(() => {
    setDigitalData({});
  }, [pathname, search]);
}
